import React, { useState, useRef, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const iconRef = useRef(null);
  const location = useLocation();

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false);
  };

  // ✅ Close menu on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav>
      {/* Left-side Logo with Home Redirect */}
      <Link to="/" className="navbar-logo-link">
        <img src="/Image/NSLogo2 final.png" alt="Website Logo" className="navbar-logo" />
      </Link>

      {/* Menu Icon for Mobile */}
      <div
        className="menu-icon"
        ref={iconRef}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <FaBars />
      </div>

      {/* Navigation Links (Right Side) */}
      <ul
        className={`nav-links ${isOpen ? "show" : ""}`}
        ref={menuRef}
      >
        <li className="nav-item">
          <Link to="/" className="nav-link" onClick={handleNavClick}>Home</Link>
        </li>
        <li className="nav-item">
          <Link to="/about" className="nav-link" onClick={handleNavClick}>About</Link>
        </li>
        <li className="nav-item">
          <Link to="/services" className="nav-link" onClick={handleNavClick}>Services</Link>
        </li>
        <li className="nav-item">
          <Link to="/contact" className="nav-link" onClick={handleNavClick}>Contact</Link>
        </li>
        <li className="nav-item">
          <Link to="/career" className="nav-link" onClick={handleNavClick}>Career</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
